import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type fetchDetailingScreenplayProps = {
  cdScreenplayTest: number
}

export const fetchScreenplay = () => {
  return new ServicesUseCase('/template/roteiroTeste', makeAxiosHttpClient())
}

export const fetchDetailingScreenplay = ({
  cdScreenplayTest
}: fetchDetailingScreenplayProps) => {
  return new ServicesUseCase(
    `/template/roteiroTesteDetalhamento?cdRoteiroTeste=${cdScreenplayTest}`,
    makeAxiosHttpClient()
  )
}

export const updateDetailingScreenplay = () => {
  return new ServicesUseCase('/template/updateRoteiro', makeAxiosHttpClient())
}

export const saveDetailingScreenplay = () => {
  return new ServicesUseCase('/template/saveRoteiro', makeAxiosHttpClient())
}

export const deleteDetailingScreenplay = ({
  cdScreenplayTest
}: fetchDetailingScreenplayProps) => {
  return new ServicesUseCase(
    `/template/deleteRoteiro/${cdScreenplayTest}`,
    makeAxiosHttpClient()
  )
}
